import ConditionLegend from './ConditionLegend';

export default ConditionLegend;
